import { IAddressDetail, IGeo, IOfferGeo } from '../../../types';
import { map, prop, pick } from 'ramda';

const addressToString = (data: IAddressDetail[]): string => {
  return map(prop('value'), data).join(', ');
};

export const prepareGeo = (geo: IOfferGeo): IGeo => {
  return {
    ...pick(['regionId', 'undergrounds', 'highways', 'coordinates', 'title', 'railways', 'timezone'], geo),
    address: addressToString(geo.address),
  };
};
